import { Box, useTheme } from '@material-ui/core';
import AsyncFileDropZone from 'components/AsyncFileDropZone/AsyncFileDropZone';
import AsyncPhotoEditorV2 from 'components/AsyncPhotoEditorV2/AsyncPhotoEditorV2';
import { FC, Fragment, memo, useEffect, useState } from 'react';
import { IOutputExtended, IRightFormComponentProps } from 'shared/interfaces/IModalForm';
import { v4 as uuidv4 } from 'uuid';
import ImageUploadedPlaceHolder from './ImageUploadedPlaceHolder/ImageUploadedPlaceHolder';

export const REJECT_WIDTH_QUANTITY = 400;
export const REJECT_HEIGHT_QUANTITY = 400;

export enum ImageQuanlityLevel {
  None = 'None',
  Reject = 'Reject',
  Bad = 'Bad',
  Accept = 'Accept',
}

const RightFormComponent: FC<IRightFormComponentProps> = ({
  handleRemoveImages,
  handleUploadImages,
  uploadedFiles,
  filesToBeSaved,
  handleFilesToBeSaved,
  handleOnDragEnd,
}) => {
  const fileNotEmpty = (length: number) => filesToBeSaved?.length > length;

  const theme = useTheme();
  const [showEditor, setShowEditor] = useState(false);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const handleEditorSave = (image: IOutputExtended) => {
    handleFilesToBeSaved({
      ...image,
      id: uuidv4(), // creating an ID for Drag and Drop Functionality
      temp_modified_attachment: URL.createObjectURL(image.modified_attachment as Blob), // Creating a temp modifieid attachment to prevent recreation in ImageUploadedPlaceholder.tsx when re-rendered
    });
    if (currentFileIndex + 1 < uploadedFiles?.length && filesToBeSaved?.length + 1 < 5) {
      setCurrentFileIndex((prevIndex) => prevIndex + 1);
      setShowEditor(true);
    } else {
      setShowEditor(false);
      handleUploadImages([]);
    }
  };

  useEffect(() => {
    if (uploadedFiles?.length > 0 && !showEditor) {
      setShowEditor(true);
      setCurrentFileIndex(0);
    }
  }, [uploadedFiles?.length]);

  return (
    <>
      {showEditor ? (
        <AsyncPhotoEditorV2
          key={currentFileIndex}
          isLandscapeThumbnail
          {...{
            patchMultipleMediaAsync: () => {},
            patchMediaTagsAsync: () => {},
            uploadMediaMutateAsync: () => {},
            updateSkillAsync: () => {},
          }}
          setFixDefaultRatio="landscape"
          variant="default"
          enableUndo={true}
          skillsData={{
            id: '',
            type: 'skill',
            attributes: {
              id: '',
              skills: [],
            },
          }}
          mediaData={[]}
          mediaTags={[]}
          show={showEditor}
          images={[uploadedFiles[currentFileIndex]]}
          handleOnSaveCar={handleEditorSave}
          close={() => {
            if (currentFileIndex + 1 === uploadedFiles?.length) {
              handleUploadImages([]);
              setShowEditor(false);
            } else {
              setCurrentFileIndex((prevIndex) => prevIndex + 1);
            }
          }}
          onSuccessImageUpdate={() => {}}
          onSuccessImageUpload={() => {}}
        />
      ) : null}

      <Box height={'100%'} width={'100%'}>
        <Box width={'100%'} height={fileNotEmpty(3) ? '52%' : fileNotEmpty(0) ? '78%' : '100%'} pb={0.8}>
          <AsyncFileDropZone
            theme={theme.palette.type}
            hideNote={true}
            fileTypes={'images'}
            getUploadedFiles={(file: File[]) => {
              handleUploadImages(file);
            }}
          />
        </Box>
        {filesToBeSaved?.length > 0 && !showEditor ? (
          <Box
            component={'div'}
            height={fileNotEmpty(3) ? '48%' : '22%'}
            width={'100%'}
            overflow={'auto'}
            marginTop={1}
          >
            <ImageUploadedPlaceHolder
              handleRemoveImages={handleRemoveImages}
              filesToBeSaved={filesToBeSaved}
              handleOnDragEnd={handleOnDragEnd}
            />
          </Box>
        ) : (
          <Fragment />
        )}
      </Box>
    </>
  );
};

export default memo(RightFormComponent);
